import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { decryptFuncCode } from '@components/common';
import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';
import Swal from 'sweetalert2';

const Barcode = lazy(() => import('react-barcode'));

const BarcodeStyle = styled.div`
  img {
    width: 50%;
  }
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 24px;
  width: min(420px, 90vw);
`;

const CodeArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 28px;
  padding: 8px 0;
`;

const CodeBlock = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  h2 {
    margin: 0;
    color: #374151;
    font-size: 16px;
  }

  svg.barcode {
    max-width: 100%;
    height: auto;
  }
`;

const PageBarcode = () => {
  const { usercode } = useParams();
  const [barcodeData, setBarcode] = useState();

  const getCode = () => {
    try {
      // useParams는 URL을 decode하므로 base64의 '+'가 space로 바뀜. 원본 복원.
      const codedata = (usercode || '').replace(/ /g, '+');
      const replaceData = codedata.replace(/samlet/gi, '/');
      decrypt(replaceData);
    } catch (error) {
      console.error('[barcode] code parsing failed');
    }
  };

  const decrypt = (codedata) => {
    const data = decryptFuncCode(codedata);
    if (!data) {
      Swal.fire({
        text: '잘못된 접근입니다. 로그인 화면으로 이동합니다.',
        timer: 3000,
      }).then(() => {
        window.location.href = `${process.env.PUBLIC_URL}/`;
      });
    } else {
      setBarcode(data);
    }
  };

  useEffect(() => {
    getCode();
  }, []);
  return (
    <>
      {usercode && (
        <BarcodeStyle>
          <CodeArea>
            {barcodeData && (
              <>
                <CodeBlock>
                  <h2>QR 코드</h2>
                  <QRCodeSVG value={barcodeData} size={220} level="M" />
                </CodeBlock>
                <CodeBlock>
                  <h2>바코드</h2>
                  <Suspense fallback={<div>Loading...</div>}>
                    <Barcode
                      className="barcode"
                      displayValue={false}
                      width={1.6}
                      fontSize={10}
                      value={barcodeData}
                    />
                  </Suspense>
                </CodeBlock>
              </>
            )}
          </CodeArea>
          <p>{barcodeData && barcodeData.replace('"', '').split('-')[0]}</p>
          <img
            alt="logo"
            src="https://user-images.githubusercontent.com/82793902/171102074-52e90618-4d38-4734-bd99-84f97a8c4a32.png"
          />
        </BarcodeStyle>
      )}
    </>
  );
};
export default PageBarcode;
